import styled, { css } from 'styled-components';
import { media, layout } from '@prisjakt/ui-base';
import Button from '@prisjakt/ui-button';

const desktopPadding = layout.spacing.xSmall;
interface LinkProps {
  small?: boolean;
}
export const LinkDesktop = styled(Button)<LinkProps>`
  width: 100%;
  white-space: normal;
  text-transform: none;
  padding: ${desktopPadding} 0 ${desktopPadding} ${desktopPadding};
  margin-right: ${layout.spacing.xSmall};
  ${media.mediumDown`
    display: none;
  `}
`;

export const LinkMobile = styled(Button)<LinkProps>(
  props => css`
    color: ${props.theme.buttons.positive.bg};
    padding: 5px 2px;
    ${media.largeUp`
      display: none;
    `}
  `
);

type StoreLinkProps = {
  disabled?: boolean;
  visible?: boolean;
};

export const StoreLink = styled.div<StoreLinkProps>(
  props => css`
    display: flex;
    align-items: center;
    visibility: ${props.visible ? 'visible' : 'hidden'};

    ${props.disabled &&
      css`
        ${LinkDesktop} {
          color: ${p => p.theme.text.tertiary};
          font-weight: normal;
          text-transform: none;
        }
      `}
  `
);
